<template>
  <div
    class="search-box filter"
    :class="isMobile ? 'is-mobile': ''"
    :ref="`filter-${id}`">
    <button
      aria-haspopup="listbox"
      type="button"
      class="form-control filter-dropdown-toggle"
      :id="`button-${id}`"
      @click="toggleDropdown"
      :class="isThin ? 'is-thin' : ''">

      <i v-if="!isMobile" :class="icon" class="icon sm"></i>
      {{ getDropdownLabel }}
      <i :class="isOpened ? 'icon-arrow-up' : 'icon-arrow-down'" class="toggle-arrow-icon sm"></i>
    </button>
    <div
      v-show="isOpened"
      v-click-outside="{
        exclude: [`filter-${ id }`],
        handler: 'onClose'
      }"
      class="options-group mb-5 filter-dropdown">
      <ul ref="content" role="listbox" class="options-content" :aria-activedescendant="options[0]">
        <li v-if="!isMobile" role="separator" class="option-header">{{ title }}</li>
        <Option
          v-if="allOptions"
          :isSelected="isOptionSelected(allOptions)"
          :option="allOptions"
          @select="onSelect"/>
        <Option
          v-for="(option, index) in options"
          :key="index"
          :isSelected="isOptionSelected(option)"
          :option="option"
          @select="onSelect"/>
        <OptionLink
          v-if="link"
          :data="link"/>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Option from '@/components/Option'
import OptionLink from '@/components/OptionLink'
import { capitalize, isEmptyObject } from '@/infrastructure/Utils'

export default {
  name: 'Dropdown',
  components: {
    Option,
    OptionLink
  },
  props: {
    title: String,
    id: String,
    icon: String,
    options: Array,
    allOptions: Object,
    link: Object,
    presettedLabel: String,
    isThin: Boolean,
    isFilter: Boolean,
    selectedOption: Number,
    isMobile: Boolean
  },
  data: () => {
    return {
      isOpened: false,
      isAllOptionSelected: true,
      currentSelection: {}
    }
  },
  methods: {
    toggleDropdown () {
      this.isOpened = !this.isOpened
    },

    onClose () {
      if (!this.isMobile) {
        this.isOpened = false
      }
    },

    onSelect (element) {
      this.$emit('select', element)
      this.onClose()
    },

    isOptionSelected (option) {
      if (this.isFilter) {
        const currentSelection = this.getSelectedFilter(capitalize(this.id))

        return !isEmptyObject(currentSelection) ? currentSelection.key === option.key : option.key === this.allOptions.key
      }

      return this.selectedOption === option.key
    }
  },
  computed: {
    ...mapGetters(['getSelectedFilter', 'getSelectedPageSize']),
    getDropdownLabel () {
      if (this.isMobile) {
        return this.title
      }
      const currentSelection = this.selectedOption || this.getSelectedFilter(capitalize(this.id)).name
      const dynamicLabel = !isEmptyObject(currentSelection) ? currentSelection : this.allOptions && !isEmptyObject(this.allOptions) ? this.allOptions.name : this.options[0].name

      return this.presettedLabel ? `${this.presettedLabel}: ${dynamicLabel}` : dynamicLabel
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.filter {
  position: relative;
  margin-right: 20px;

  &-dropdown-toggle {
    position: relative;
    text-align: left;
    border: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    height: auto;
    width: 200px;
    padding: 20px 16px;
    padding-right: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid #F1F1F1;

    &.is-thin {
      width: 150px;
      padding: 10px 16px;
    }

    .icon {
      margin-right: 6px;
    }

    .toggle-arrow-icon {
      position: absolute;
      line-height: 12px;
      font-size: 12px;
      right: 6px;
      top: calc(50% - 6px);
    }
  }

  &-dropdown {
    text-align: left;
  }

  &.is-mobile {
    display: block;
    margin: 0;
    overflow: initial;
    height: auto;

    & .filter-dropdown-toggle {
      width: 100%;
      border: none;
      border-bottom: 1px solid #F1F1F1;
    }

    & .filter-dropdown {
      position: initial;
      width: 100%;
      border: none;
      border-bottom: 1px solid #F1F1F1;
      transform: initial;
      margin: 0 !important;

      &::before {
        display: none;
      }

      & .options-content {
        overflow-y: initial;
        overflow-x: initial;
        max-height: initial;
      }
    }
  }

}

</style>
